import {
  deleteSingleProduct,
  fetchSingleProduct,
  type ProductDeleteParams
} from 'Services/ProductManagement/Features/Product/productSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { useEffect } from 'react'

function useSingleProduct(id: string | undefined) {
  const dispatch = useAppDispatch()
  const { singleProduct, singleLoading, deleteLoading, submitLoading } = useTypedSelector(
    state => state.product
  )

  useEffect(() => {
    if (!id) return
    dispatch(fetchSingleProduct({ id }))
  }, [id])

  const deleteProduct = (id: string, params?: ProductDeleteParams) => {
    return dispatch(deleteSingleProduct({ id, ...params }))
  }

  return {
    singleProduct,
    singleLoading,
    deleteProduct,
    deleteLoading,
    submitLoading
  }
}

export default useSingleProduct
